/** A link that looks like the primary `Button` (the hand-offs are real anchors, so they open in a tab). */
export const PRIMARY_LINK =
  "inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-accent-700 px-4 text-sm font-medium text-white transition-colors hover:bg-accent-800 dark:bg-accent-600 dark:hover:bg-accent-500";
